const contextTypes = {
  // The public methods that all controls should be able to use
  updateStateFromVideo: React.PropTypes.func,
  togglePause: React.PropTypes.func,
  toggleMute: React.PropTypes.func,
  toggleError: React.PropTypes.func,
  toggleBeenPlayed: React.PropTypes.func,
  toggleEnded: React.PropTypes.func,
  exitFullScreen: React.PropTypes.func,
  toggleFullScreenByUser: React.PropTypes.func,
  toggleInfoOverlay: React.PropTypes.func,
  setQuality: React.PropTypes.func,
  afterShareClicked: React.PropTypes.func,

  simple: React.PropTypes.bool,
  mobileMode: React.PropTypes.bool,

  play: React.PropTypes.func,
  pause: React.PropTypes.func,
  mute: React.PropTypes.func,
  unmute: React.PropTypes.func,
  seek: React.PropTypes.func,
  resetSeek: React.PropTypes.func,
  setVolume: React.PropTypes.func,

  videoItem: React.PropTypes.object,
  channelData: React.PropTypes.object,
  appSettings: React.PropTypes.object,
  showChannelCover: React.PropTypes.bool,
  canShowChannelCover: React.PropTypes.bool,
  videoUrls: React.PropTypes.object,
  storyboardUrl: React.PropTypes.string,
  quality: React.PropTypes.string,
  openPreviewPrompt: React.PropTypes.func,
  showControls: React.PropTypes.bool,

  // Standard video properties
  duration: React.PropTypes.number,
  currentTime: React.PropTypes.number,
  userTime: React.PropTypes.number,
  buffered: React.PropTypes.object,
  fullScreen: React.PropTypes.bool,
  infoOverlay: React.PropTypes.any,
  infoOverlayProps: React.PropTypes.object,
  paused: React.PropTypes.bool,
  muted: React.PropTypes.bool,
  loop: React.PropTypes.bool,
  volume: React.PropTypes.number,
  readyState: React.PropTypes.number,
  width: React.PropTypes.number,
  height: React.PropTypes.number,

  // Non-standard state computed from properties
  percentageBuffered: React.PropTypes.number,
  percentagePlayed: React.PropTypes.number,
  error: React.PropTypes.bool,
  loading: React.PropTypes.bool,
  beenPlayed: React.PropTypes.bool,
  ended: React.PropTypes.bool,
  fadeControls: React.PropTypes.bool,
};

export default contextTypes;

export function pickContextTypes(...types) {
  return _.pick(contextTypes, types);
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/context-types.js